<div class="flex flex-col" style="width: 100%" particleHelpNotes helpNoteId="home-details">
  <div class="container-breadcrums-search flex flex-row justify-between items-center">
    <particle-breadcrumbs [breadcrumbs]="breadcrumbs" [iconClass]="icon"
                          (dropDownSelectionChanged)="breadCrumbSelectionChange($event)"></particle-breadcrumbs>
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container m-l-20">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="resetReport()"
                  particleAnalytics
                  analyticsCategory="analytics"
                  analyticsAction="reset-Report"
                  [disabled]="(!dataLoaded && !failureResponse) || isDefaultReport"
          >Reset Report
          </button>
          <!--  <button mat-button class="orbitax-flat-button m-l-20" (click)="refreashReportService()"
                   particleAnalytics
                   analyticsCategory= "analytics"
                   analyticsAction= "reset-Report"
                   [disabled]="(!dataLoaded && !failureResponse) || !hasEntity"
           >Refresh Report</button>-->
        </div>
      </div>
    </div>
  </div>
  <mat-sidenav-container class="particle-page-content-container">
    <mat-tab-group (selectedIndexChange)="onSelectedTabChanged($event)"
                   [selectedIndex]="selectedIndex">
      <mat-tab *ngFor="let tab of tabGroup?.tabs; let i = index" label="{{tab.displayText}}">
        <ng-template mat-tab-label>
          <i class="{{tab.icon}}"></i>
          {{tab.displayText}}
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div *ngIf="!dataLoaded && !failureResponse" [ngClass]="dataLoaded? 'hide' : ''"
         class="empty-content flex flex-col justify-center items-center full-grow-no-shrink-no-basis "
         >
      <div class="text-container">
        <div class="svg-container" [ngStyle]="loadingPercentage">
          <img
            src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
            alt="">
        </div>
        <h1>Loading...</h1>
        <div class="text">Please wait we are preparing your search results. This may take up to 60 seconds depending on
          the size of the data.
        </div>
        <div class="instruction">You can navigate ITP and access your Orbitax Solutions from the left-hand menu at any
          time.
        </div>
      </div>
    </div>
    <div *ngIf="!failureResponse" [ngClass]="failureResponse || !dataLoaded ? 'hide' : ''" class="page-layout simple full-grow-no-shrink-no-basis "
         >
      <!-- CONTENT -->
      <div class="content">

        <div class="analytics-container flex flex-col">
          <div [style.visibility]="dataLoaded?'visible':'hidden'" #report id="reportsContainer" class="main-content">
          </div>
        </div>
      </div>
      <!-- / CONTENT -->
    </div>
    <div class="empty-content flex flex-col justify-center items-center full-grow-no-shrink-no-basis " *ngIf="failureResponse"
         [ngClass]="!failureResponse || dataLoaded ?'hide' : ''" >
      <div class="text-container">

        <div class="svg-container" style="background: linear-gradient(to top, red 100%, #eee 0%);">
          <img
            src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
            alt="">
        </div>
        <h1>Sorry, there was an error...</h1>
        <div class="text">We couldn't load your data as the query exceeded the data limit. Please adjust the settings to
          reduce the size of the query, and try again.
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>
